module.exports = __webpack_public_path__ + "media/images/icon-benefits-physical-0a2304c3bf08988a1dc54691cfb29cf3.png";